import type { ComponentType } from 'react';
import React from 'react';
import type { Params } from 'react-router-dom';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

type WithRouterProps = {
  params: Params;
  navigate: ReturnType<typeof useNavigate>;
  pathname: string;
};

export function withRouter<T extends object>(
  WrappedComponent: ComponentType<T & WithRouterProps>
): ComponentType<T> {
  function ComponentWithRouterProps(props: T) {
    const params = useParams();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    return (
      <WrappedComponent
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        params={params}
        navigate={navigate}
        pathname={pathname}
      />
    );
  }

  ComponentWithRouterProps.displayName = `withRouter(${
    WrappedComponent.displayName ?? WrappedComponent.name ?? 'Component'
  })`;

  return ComponentWithRouterProps;
}
